import React, { useRef } from "react";
import { message } from "antd";
import { useWarehouseModel } from "../warehouseModel";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText } from "@/utils/utils"
import { IWarehouseFileds } from "../warehouseService";

import { useDictModel } from "../../dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export function AddDetailDrawer() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName } = useDictModel();
    const { addWareVisible: visible, setAddWaerVisible, insertWarehouse } = useWarehouseModel();
    const formRef = useRef<IYhFormRef>();

    const onCancel = () => {
        setAddWaerVisible(false);
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(res => {
            let typeName = getTreeNodeName(res.typeCode)
            insertWarehouse({ ...res, typeName } as IWarehouseFileds).then(res => {
                res && onCancel()
            })
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    const formConfig: IYhForm = {
        formRef,
        labelCol: { span: 6 },
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "仓库编码",
                fieldLabel: Locale["Warehouse Code"],
                fieldName: "code",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "仓库名称",
                fieldLabel: Locale["Warehouse Name"],
                fieldName: "name",
                span: 24,
                // rules: [{ required: true, message: "请输入仓库名称" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "仓库类别",
                fieldLabel: Locale["Warehouse Type"],
                fieldName: "typeCode",
                span: 24,
                options: getSelectedDictOne(DictCodeEnmu.CK_TYPE),
                // rules: [{ required: true, message: "请选择仓库类别" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系人",
                fieldLabel: Locale["Contact"],
                fieldName: "contact",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系电话",
                fieldLabel: Locale["Contact Number"],
                fieldName: "phone",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系地址",
                fieldLabel: Locale["Address"],
                fieldName: "address",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "备注",
                fieldLabel: Locale["Note"],
                fieldName: "note",
                span: 24,
            }
        ]
    };
    return (
        <YHDrawer
            {...{
                title: Locale["New Warehouse"],
                visible,
                onCancel,
                okText: Locale["Save"],
                cancelText:Locale["Back"],
                onOk: onSubmit
            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}
